/**
 * Drop a Hint — posts to CATALOG's app-proxy route and says only what is true.
 *
 * 🔴 THE MESSAGE IS CHOSEN BY THE RESPONSE, NEVER BY THIS FILE. The route returns
 * `sending: false` while the send gate is off, and it queues rather than rejects. So a
 * hint is genuinely SAVED and genuinely NOT SENT, and the copy has to say the first
 * without implying the second. "We'll send it on the day you chose" is a promise with a
 * delayed fuse — exactly the shape of claim this storefront spent a day removing.
 *
 * ⚠️ THE HONEYPOT'S SUCCESS IS INDISTINGUISHABLE FROM A REAL ONE, on purpose. The route
 * answers 200 with `id: null`, and this shows the same message it shows a person. Telling
 * a bot which field it tripped is how it learns to skip that field next time.
 */
(function () {
  var root = document.querySelector('[data-djh-hintform]');
  var cfgEl = document.querySelector('[data-djh-hintform-config]');
  if (!root || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var form = root.querySelector('[data-djh-hintform-form]');
  var donePanel = root.querySelector('[data-djh-hintform-done]');
  var doneLine = root.querySelector('[data-djh-hintform-done-line]');
  var doneSub = root.querySelector('[data-djh-hintform-done-sub]');
  var status = root.querySelector('[data-djh-hintform-status]');
  var submit = root.querySelector('[data-djh-hintform-submit]');
  var dateEl = form.querySelector('[name="send_on"]');
  // An empty date shows its mm/dd/yyyy in the example-text tone, so a sample is never read as an answer (Henry, 2026-10-10).
  if (dateEl) {
    var markDate = function () { if (dateEl.value) dateEl.removeAttribute('data-empty'); else dateEl.setAttribute('data-empty', ''); };
    markDate();
    dateEl.addEventListener('input', markDate);
    form.addEventListener('reset', function () { setTimeout(markDate, 0); });
  }

  // The shop's own day, not UTC. `toISOString()` is midnight UTC, which in Hawaiʻi is the
  // previous afternoon — so a min built from it would refuse today. Same trap CATALOG
  // records for their string comparison, arriving from the other side.
  function localISO(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' +
           String(d.getDate()).padStart(2, '0');
  }
  var today = new Date();
  var maxDay = new Date(); maxDay.setDate(maxDay.getDate() + 365);
  if (dateEl) { dateEl.min = localISO(today); dateEl.max = localISO(maxDay); dateEl.value = localISO(today); }

  function say(text, isError) {
    status.textContent = text;
    status.hidden = !text;
    status.classList.toggle('is-error', !!isError);
  }

  // THE PIECE IS COPIED FROM THE PDP, NEVER RECOMPUTED. The picker already keeps
  // [data-djh-main-image], [data-djh-price-display] and [data-djh-variant-id] correct;
  // reading them at open time is one source. Rebuilding the variant logic here is how
  // a hint ends up naming a size the sender did not choose.
  // 🔴 THE OPENER MAY CARRY THE PIECE, AND ON THE WISHLIST IT ALWAYS DOES. One dialog,
  // four cards: the button that opens it says which piece rather than the page rendering
  // a dialog per card. On a product page no opener carries data attributes and this does
  // nothing, so the PDP path below is untouched.
  //
  // ⚠️ TEXT IS SET, NEVER INTERPOLATED. A title arrives here through a JSON endpoint and
  // lands in a form; `textContent` and `.src` are assignments, not markup.
  function seedFromOpener(btn) {
    mode = btn && btn.getAttribute('data-mode') === 'share' ? 'share' : 'hint';

    var heading = root.querySelector('[data-djh-hintform-heading]');
    var lead = root.querySelector('[data-djh-hintform-lead]');
    if (heading && cfg.titles) heading.textContent = cfg.titles[mode] || heading.textContent;
    if (lead && cfg.leads) lead.textContent = cfg.leads[mode] || lead.textContent;

    var handleField = form.querySelector('[data-djh-hintform-handle]');
    var variantField = form.querySelector('[data-djh-hintform-variant]');
    var handlesField = form.querySelector('[data-djh-hintform-handles]');

    // ONE OF THE TWO IS ALWAYS DISABLED. A disabled field is not submitted, so the body
    // carries either `product_handle` or `handles` and never a confusing both — which is
    // what the route would otherwise have to arbitrate.
    if (mode === 'share') {
      if (handleField) handleField.disabled = true;
      if (variantField) variantField.disabled = true;
      if (handlesField) {
        handlesField.disabled = false;
        handlesField.value = (btn && btn.getAttribute('data-handles')) || '';
      }
      return;
    }

    if (handlesField) handlesField.disabled = true;
    if (handleField) handleField.disabled = false;
    if (variantField) variantField.disabled = false;

    if (!btn || !btn.getAttribute('data-handle')) return;

    if (handleField) handleField.value = btn.getAttribute('data-handle');
    if (variantField) variantField.value = btn.getAttribute('data-variant') || '';

    var pieces = root.querySelector('[data-djh-hintform-pieces]');
    var shot = root.querySelector('[data-djh-hintform-image]');
    var title = root.querySelector('[data-djh-hintform-piece-title]');
    var price = root.querySelector('[data-djh-hintform-price]');
    if (pieces) pieces.hidden = false;
    if (shot) {
      var src = btn.getAttribute('data-image');
      shot.hidden = !src;
      if (src) shot.src = src;
    }
    if (title) title.textContent = btn.getAttribute('data-title') || '';
    if (price) price.textContent = btn.getAttribute('data-price') || '';
  }

  var mode = 'hint';

  function syncPiece() {
    // Nothing on the PDP to read from when the dialog was opened from a card.
    if (mode === 'share' || !document.querySelector('.djh-product__form')) return;
    var img = document.querySelector('[data-djh-main-image]');
    var shot = root.querySelector('[data-djh-hintform-image]');
    if (img && shot && img.currentSrc) shot.src = img.currentSrc;

    var price = document.querySelector('[data-djh-price-display]');
    var slot = root.querySelector('[data-djh-hintform-price]');
    if (price && slot) slot.textContent = price.textContent.trim();

    // `.djh-product__form [name="id"]` — THE SAME SELECTOR THE SECTION USES, and it has
    // to be, because the PDP carries the chosen variant in three different shapes: a
    // <select name="id"> on a one-option product, a hidden [data-djh-variant-id] beside
    // the option selects on a multi-option one, and a plain hidden input where there are
    // no options at all. Measured on the barrel ring, 2026-09-07: [data-djh-variant-id]
    // is ABSENT there, so reading only that hook left the hint pointing at the
    // render-time variant while the customer had chosen size 6.
    //
    // An empty value is the explicit-choice state — nothing picked yet — and must not
    // overwrite the default.
    var live = document.querySelector('.djh-product__form [name="id"]');
    var field = form.querySelector('[name="variant_id"]');
    if (live && field && live.value) field.value = live.value;
  }

  // 🔴 PARSED AS A LOCAL DATE, NEVER `new Date('2026-10-22')`. That form is midnight UTC,
  // which in Hawaiʻi is the previous AFTERNOON — so a hint scheduled for the 22nd would be
  // read back to the sender as the 21st. The same trap this file already avoids when it
  // sets the picker's min, arriving from the other side.
  function localDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
    if (!m) return null;
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }

  function isToday(d) {
    var n = new Date();
    return d && d.getFullYear() === n.getFullYear() && d.getMonth() === n.getMonth() && d.getDate() === n.getDate();
  }

  // "Thursday, October 22" — American order, which is convention 7 and not a preference.
  function longDate(d) {
    try {
      return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] || ''; });
  }

  function showForm() {
    form.hidden = false;
    if (donePanel) donePanel.hidden = true;
  }

  function showDone(name, when, sending) {
    var d = localDate(when);
    var today = isToday(d);
    var vars = { name: name || 'them', when: d ? longDate(d) : '' };

    // The sentence follows the ROUTE's `sending`, not this file's hope. With the gate off a
    // hint is genuinely saved and genuinely not sent, and the confirmation has to say the
    // first without implying the second.
    var key = sending
      ? (today ? 'done_today' : 'done_on')
      : (today ? 'done_held_today' : 'done_held_on');
    doneLine.textContent = fill(cfg.messages[key], vars);

    var sub = sending ? (today ? '' : cfg.messages.done_nothing_before) : cfg.messages.done_held_sub;
    doneSub.textContent = sub;
    doneSub.hidden = !sub;

    form.hidden = true;
    donePanel.hidden = false;
    donePanel.setAttribute('tabindex', '-1');
    try { donePanel.focus(); } catch (e) {}
  }

  function open(btn) {
    seedFromOpener(btn);
    syncPiece();
    showForm();
    say('');
    if (typeof root.showModal === 'function') root.showModal(); else root.setAttribute('open', '');
  }
  function close() { if (typeof root.close === 'function') root.close(); else root.removeAttribute('open'); }

  // DELEGATED, because the wishlist's openers are created by JavaScript after this file
  // has run. Binding to the buttons present at load worked on the PDP and would have
  // silently done nothing on every card.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-djh-hintform-open]') : null;
    if (!b) return;
    e.preventDefault();
    say('');
    open(b);
  });
  root.querySelectorAll('[data-djh-hintform-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!form.reportValidity()) return;

    var body = {};
    new FormData(form).forEach(function (v, k) { body[k] = v; });

    submit.disabled = true;
    say(cfg.messages.sending, false);

    // 🔴 FORM-ENCODED, NOT JSON, AND THIS IS THE WHOLE REASON THE FORM NEVER WORKED.
    // Measured against the live route 2026-09-07, same payload, three encodings:
    //
    //   application/json                 400  all six fields reported MISSING
    //   application/x-www-form-urlencoded 200  ok:true signatureVerified:true
    //   multipart/form-data              400  all six fields reported MISSING
    //
    // The route parses one encoding and this file was sending another, so every
    // submission came back "Which product the hint is about is missing." with five
    // more like it — for fields that were all present in the body. Nobody had seen
    // it because the PDP does not open this dialog yet (product.liquid keeps the
    // share sheet until the send gate is on), so the form has never been submitted
    // by a person.
    //
    // ONE ENCODING, NOT A CHAIN. Trying JSON and falling back on 400 would fire a
    // guaranteed failure on every hint — the same mistake djh-customer-profile.js
    // made with the proxy subpath and had removed on 2026-08-25.
    fetch(mode === 'share' ? (cfg.shareEndpoint || cfg.endpoint) : cfg.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: new URLSearchParams(body).toString()
    })
      .then(function (res) { return res.json().then(function (d) { return { status: res.status, data: d }; }); })
      .then(function (r) {
        submit.disabled = false;
        if (r.status === 200) {
          // THE CONFIRMATION REPLACES THE FORM, and it names the person and the day. A
          // reset form with a live submit button underneath a one-line status is what
          // Henry saw as "the dialog doesn't go away" — it had not gone away AND it looked
          // unsubmitted, which invites sending the same hint twice.
          //
          // `sending` still decides what is promised. Absent is treated as false: a route
          // that did not say it is sending has not said it will.
          say('');
          showDone(body.recipient_name, body.send_on, !!(r.data && r.data.sending));
          form.reset();
          if (dateEl) dateEl.value = localISO(new Date());
          return;
        }
        if (r.status === 429) {
          say(cfg.messages.rate_limited, true);
          return;
        }
        if (r.status === 400 && r.data) {
          // EVERY problem at once — the route returns them all and a form that reveals
          // one error per attempt makes a person submit four times to learn four things.
          var all = Array.isArray(r.data.errors) && r.data.errors.length
            ? r.data.errors.join(' ')
            : (r.data.error || cfg.messages.failed);
          say(all, true);
          return;
        }
        say(cfg.messages.failed, true);
      })
      .catch(function () {
        submit.disabled = false;
        say(cfg.messages.failed, true);
      });
  });
})();
